import React from 'react';

export const LoadingScreen = () => {
    return (
        <div className="loading-container">
            <div className="spinner-border animate">
            </div>
        </div>
    )
}